import { useState, useRef } from "react"
import printJS from 'print-js'
import Grid from '@material-ui/core/Grid'
import Dialog from "@base/Dialog";
import Toast from '@base/Toast'
import ButtonPrimary from '@base/Button'
import AddIcon from '@material-ui/icons/AddOutlined'
//import ObjetoPostalService from '@services/ObjetoPostalService'
import EscolaService from '@services/EscolaService'
import { Card, CardContent } from "@material-ui/core"
import SelectOption from '@base/Inputs/Select'
import TextField from "@base/Inputs/Text"
import { numberMask } from '@helpers/MaskHelper'

export const ImprimirSegundaViaDialog = (props) => {
	const toastRef = useRef(null);
	const [nivel, setNivel] = useState("");
	const [quantidade, setQuantidade] = useState("");

	const submit = () => {
		props.aoFechar();
		setNivel('');
		setQuantidade('');
		props.handleLoading(false);
	}

	/*const imprimirEtiquetaEnvelope = () => {
		props.aoFechar();
		props.handleLoading(true);
		ObjetoPostalService.imprimirEtiqueta(props.processo,  props.escola).then(valores => {
			let file = new Blob([valores.data], { type: valores.data.type });
			let fileURL = URL.createObjectURL(file);
			printJS({
				printable: fileURL,
				type: "pdf",
				showModal: "true",
				modalMessage: 'Imprimindo Etiqueta do Envelope...'
			});
		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao imprimir etiqueta do Envelope."));
		props.handleLoading(false);
	}*/

	const imprimirNovoCodigoCartao = () => {
		if ((nivel) && (quantidade)) {
			props.aoFechar();
			props.handleLoading(true);
			EscolaService.downloadNovosCodigos(props.processo,  props.escola, nivel, quantidade).then(valores => {
				let file = new Blob([valores.data], { type: valores.data.type });
				let fileURL = URL.createObjectURL(file);
				printJS({
					printable: fileURL,
					type: "pdf",
					showModal: "true",
					modalMessage: 'Imprimindo Etiqueta Cartão...'
				});
			}).catch(async error => {
				const errJson = JSON.parse(await error.response.data.text()); // extrair texto do blob retornado
				toastRef.current.show("error", "Ocorreu um Problema ao imprimir novo codigo de Cartão:" + errJson.mensagens.map(m => m).join(''));
			}).finally(() => {
				setNivel('');
				setQuantidade('');
				props.handleLoading(false);
			});
		} else {
			toastRef.current.show("warning", "Preencha os campos Nível e Quantidade.")
		}
	}

	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={props.aoFechar}
				openDialog={props.aberto}
				title="Impressão de Documentos"
				actions={<ButtonPrimary onClick={submit} name="Fechar" />}>
				<Card>
					<CardContent style={{ fontSize: 12, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>Novo Código para Cartão</CardContent>
					<CardContent>
						<Grid container spacing={5}>
							<Grid item sm={8} lg={3}>
								<SelectOption
									label='Nível'
									value={nivel}
									name='nivel'
									onChange={(e) => setNivel(e.target.value)}
									options={[
										{ "label": "1", "value": "1" },
										{ "label": "2", "value": "2" },
										{ "label": "3", "value": "3" },
									]}
								/>
							</Grid>
							<Grid item sm={8} lg={3}>
								<TextField
									label='Quantidade'
									value={quantidade}
									name='quantidade'
									inputProps={{ maxLength: 3 }}
									onChange={(e) => setQuantidade(numberMask(e.target.value.trim()))}
								/>
							</Grid>
						</Grid>

						<Grid container spacing={5}>
							<Grid item sm={8}>
								<ButtonPrimary
									onClick={imprimirNovoCodigoCartao}
									name="Imprimir Códigos"
									startIcon=<AddIcon />
									disabled={false}
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Dialog>
		</>
	);
}

export default ImprimirSegundaViaDialog;
